import { redirect } from 'react-router-dom'

import { fetchCurrentUser } from '@/api/queries/auth'
import type { UserRole } from '@/lib/permission'
import { useAuthStore } from '@/stores/auth.store'

export const roleGuard = (allowedRoles: UserRole[]) => async () => {
  const { accessToken, setUser } = useAuthStore.getState()
  let { user } = useAuthStore.getState()

  if (!accessToken) throw redirect('/login')
  if (!user) {
    user = await fetchCurrentUser()
    setUser(user)
  }
  if (!allowedRoles.includes(user.role)) throw redirect('/403')

  return null
}
